module.exports = __webpack_public_path__ + "static/media/site-logo.9ce40541.png";